export const UsuarioPermissaoEnum = {
  UsuarioNaoLogado: {
    menuId: -2,
    menu: null,
    descricao: 'Usuário NÃO pode estar logado para acessar esta página',
  },
  UsuarioLogado: {
    menuId: -1,
    menu: null,
    descricao: 'Usuário deve estar logado para acessar esta página',
  },
  // cadastros
  CadastrosDadosDaEmpresa: {
    menuId: 1,
    menu: 'Cadastros',
    descricao: 'Dados da empresa',
    perfil: 'Coordenação',
  },
  CadastrosUsuariosDeBeneficio: {
    menuId: 3,
    menu: 'Cadastros',
    descricao: 'Usuários de Benefício',
    perfil: 'Coordenação',
  },
  CadastrosDadosDaEmpresaGerenciarPermissoes: {
    menuId: 2,
    menu: 'Cadastros',
    descricao: 'Dados da empresa / Gerenciar Permissões',
    perfil: 'Coordenação',
  },
  // relatorios
  RelatoriosRelatorioDeUsuariosAtivos: {
    menuId: 5,
    menu: 'Relatorios',
    descricao: 'Relatório de usuários ativos',
    perfil: 'Coordenação',
  },
  RelatoriosSugestaoDeRota: {
    menuId: 6,
    menu: 'Relatorios',
    descricao: 'Sugestão de rota',
    perfil: 'Coordenação',
  },
  RelatoriosGerencialRecargaCerta: {
    menuId: 7,
    menu: 'Relatorios',
    descricao: 'Gerencial Recarga Certa',
    perfil: 'Coordenação',
  },
  InformeRendimentos: {
    menuId: 20,
    menu: 'Relatórios',
    descricao: 'Informe de Rendimentos',
    perfil: 'Coordenação',
  },
  // pedidos
  PedidosIntegral: {
    menuId: 19,
    menu: 'Pedidos',
    descricao: 'Integral',
    perfil: 'Coordenação',
  },
  PedidosListarPedidos: {
    menuId: 10,
    menu: 'Pedidos',
    descricao: 'Listar pedidos',
    perfil: 'Coordenação',
  },
  PedidosDemonstrativoDeFaturas: {
    menuId: 11,
    menu: 'Pedidos',
    descricao: 'Demonstrativo de faturas',
    perfil: 'Coordenação',
  },
  PedidosDevolucoesDepositoEmContaUsuario: {
    menuId: 12,
    menu: 'Pedidos',
    descricao: 'Devoluções / Depósito em conta usuário',
    perfil: 'Coordenação',
  },
  PedidosImportarDadosFazerPedido: {
    menuId: 8,
    menu: 'Pedidos',
    descricao: 'Importar dados / Fazer pedido',
    perfil: 'Coordenação',
  },
  PedidosLiberarPedidosPosPago: {
    menuId: 9,
    menu: 'Pedidos',
    descricao: 'Liberar pedidos pós-pago',
    perfil: 'Coordenação',
  },
  // ferramentas
  FerramentasImportacoes: {
    menuId: 13,
    menu: 'Ferramentas',
    descricao: 'Importações',
    perfil: 'Coordenação',
  },
  FerramentasGerarPlanilhaDeDados: {
    menuId: 15,
    menu: 'Ferramentas',
    descricao: 'Gerar planilha de Dados',
    perfil: 'Coordenação',
  },
  ExclusividadesRecargaCerta: {
    // nao encontrado
    menuId: 17,
    menu: 'Exclusividades',
    descricao: 'Recarga certa',
    perfil: 'Coordenação',
  },
  ExclusividadesSugestaoDeRotas: {
    // encontrado apenas manual do sugestao de rotas
    menuId: 18,
    menu: 'Exclusividades',
    descricao: 'Sugestão de rotas',
    perfil: 'Coordenação',
  },
  // Usuários de Benefício
  UsuariosDeBeneficioSolicitacao2aVia: {
    // nao encontrado
    menuId: 4,
    menu: 'Usuarios de Beneficio',
    descricao: 'Solicitação 2a via',
    perfil: 'Coordenação',
  },
  // Pedido Avulso
  FazerPedidoAvulso: {
    // nao encontrado
    menuId: 19,
    menu: 'Pedidos',
    descricao: 'Fazer Pedido Avulso',
    perfil: 'Coordenação',
  },
};

export type UsuarioPermissaoEnumKeys = keyof typeof UsuarioPermissaoEnum;

export enum UsuarioPermissaoFlags {
  Ativo = 'flagAtivo',
  Incluir = 'flagIncluir',
  Alterar = 'flagAlterar',
  Excluir = 'flagExcluir',
  Imprimir = 'flagImprimir',
}

export type UsuarioPermissaoFlagsKeys = keyof typeof UsuarioPermissaoFlags;
